<script setup lang="ts">
import RewardsToggle from './RewardsToggle.vue'

import type { LoyaltyReward } from '@/types/types'

const props = defineProps<{ rewards: LoyaltyReward[]; color: string }>()

const { t } = useI18n()
const { getContrast } = useColor()

const modelValue = ref('claimedRewards')
const claimedRewards = ref<LoyaltyReward[]>([props.rewards[0]])

const getRewardButtonText = (reward: LoyaltyReward) => {
  return reward.points === 0
    ? t('pages.home.get')
    : t('pages.loyaltyPage.mockup.devices.webapp.productCard.points', { points: reward?.points })
}

const getOverlayText = (reward: LoyaltyReward) => {
  const remainingPointsToUnlock = reward.points - 100
  const notEnoughPoints = remainingPointsToUnlock > 0

  return notEnoughPoints
    ? t('pages.loyaltyPage.mockup.devices.webapp.productCard.missingPoints.text', {
        points: remainingPointsToUnlock
      })
    : null
}

const shownRewards = computed(() => (modelValue.value === 'allRewards' ? props.rewards : claimedRewards.value))
</script>

<template>
  <div class="relative z-10 -mt-6 rounded-t-4xl bg-white p-4 font-serif text-foreground">
    <RewardsToggle v-model="modelValue" class="mb-6" />
    <div class="min-h-[260px]">
      <div v-if="rewards?.length > 0" class="pointer-events-none grid grid-cols-2 gap-4">
        <Reward
          v-for="reward in shownRewards"
          :key="reward.id"
          :title="reward.name"
          :img="reward.pictureUrl"
          :button-text="getRewardButtonText(reward)"
          :button-bg-color="color"
          :button-text-color="getContrast(color)"
          :overlay-text="getOverlayText(reward)"
        />
      </div>
      <div v-else class="flex min-h-[240px] items-center text-center">
        <p class="mx-auto w-3/4 text-sm font-medium text-muted-foreground">
          {{ t('pages.loyaltyPage.mockup.devices.webapp.rewards.emptyState.title') }}
        </p>
      </div>
    </div>
  </div>
</template>
